var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValecard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 30,
    viewBox: "0 0 50 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9.74852L5.01403 9.73697L5.85452 16.6551L9.58608 9.74901L12.8312 9.75764L6.62036 20.9571H3.48638L2 9.74852Z",
    fill: "#003A81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73038 20.9571L14.5348 9.73697H17.4288L19.4667 20.9571H16.4356L16.0416 18.5744L12.4852 18.5801L11.1322 20.9571H7.73038ZM13.9291 15.9924L15.2648 13.6358L15.6585 15.9924H13.9291Z",
    fill: "#003A81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8718 9.77165L24.9058 9.77741L23.0991 18.3141H27.0664L26.4985 21L19.5101 20.9571L21.8718 9.77165Z",
    fill: "#003A81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3013 9.79588L36.2712 9.81318L35.7631 12.3777H31.7843L31.4304 13.9487H35.4148L34.827 16.8425H30.8482L30.4885 18.4367H34.5186L33.9992 20.9954L26.9322 21L29.3013 9.79588Z",
    fill: "#003A81"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1587 12.3517L37.6896 9.79589H42.8719L44.573 9.00297L48.2035 9L46.7308 11.6107L43.146 11.6136L41.4563 12.3517H37.1587Z",
    fill: "#FAB100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8322 13.9556L40.5484 13.9613L42.2209 13.2335H45.8114L44.2331 16.0897H40.6483L38.97 16.829H36.2711L36.8322 13.9556Z",
    fill: "#E3002F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8989 18.4347L38.0481 18.4404L39.7235 17.7039H43.3483L41.9155 20.2685H38.3193L36.6411 21H35.3852L35.8989 18.4347Z",
    fill: "#003A81"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8718 9.79589L41.4562 12.3517L43.1459 11.6136L44.5729 9.00298L42.8718 9.79589Z",
    fill: "#D39607"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5486 13.9613L38.9702 16.829L40.6485 16.0897L42.2211 13.2335L40.5486 13.9613Z",
    fill: "#C00029"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0481 18.4404L36.6411 21L38.3193 20.2685L39.7235 17.7039L38.0481 18.4404Z",
    fill: "#00306B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValecard);
export default __webpack_public_path__ + "static/media/valecard.4293087d1ecfceea724feef1e0d07b8d.svg";
export { ForwardRef as ReactComponent };